// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'store';
import { useInactivityTimer } from 'utils/hooks';
import { AuthActions, selectLoggedUser } from 'store/modules/auth';
import { useSelector } from 'react-redux';
import { SESSION_IDLE_TIMEOUT } from 'config';

const SessionHandler = (props) => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectLoggedUser);
  const [sessionSecondsTimeout, setSessionSecondsTimeout] = useState(0);

  useInactivityTimer(
    () => dispatch(AuthActions.logout()),
    sessionSecondsTimeout,
    !!user && sessionSecondsTimeout > 0
  );

  useEffect(() => {
    if (user) {
      if (
        user.lastActivityTime &&
        user.lastActivityTime < Date.now().toString()
      ) {
        dispatch(AuthActions.logout());
      } else {
        setSessionSecondsTimeout(SESSION_IDLE_TIMEOUT);
      }
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    return () => {
      if (user && sessionSecondsTimeout) {
        const sessionSeconds = new Date(
          new Date().getTime() + sessionSecondsTimeout * 1000
        )
          .getTime()
          .toString();
        dispatch(AuthActions.updateSessionActivity(sessionSeconds));
      }
    };
    // eslint-disable-next-line
  }, []);

  return <> {props.children} </>;
};

export default SessionHandler;
